import { useTranslation } from "react-i18next";

/**
 * SkipLink - Allows keyboard users to bypass navigation
 * WCAG 2.4.1 Bypass Blocks (Level A)
 *
 *
 * Setup:
 * 1. Add <SkipLink /> as the first child of your App or Layout
 * 2. Add id="main-content" to your main content area
 *
 * Example in App.jsx:
 * ```jsx
 * import { SkipLink } from "@/components/ui/SkipLink";
 *
 * const App = () => {
 *   return (
 *     <>
 *       <SkipLink />
 *       <Sidebar />
 *       <main id="main-content" tabIndex={-1}>
 *         {children}
 *       </main>
 *     </>
 *   );
 * };
 * ```
 */
export const SkipLink = ({ href = "#main-content", children }) => {
  const { t } = useTranslation();

  return (
    <a
      href={href}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-100 focus:px-4 focus:py-2 focus:bg-background focus:text-foreground focus:border focus:border-border focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring"
    >
      {children || t("common.skipToContent", "Skip to main content")}
    </a>
  );
};

export default SkipLink;
